import React,{Component} from "react"; 
import PopUpOther from'./../PopUp/PopUpOther';
import SelectFix from './../PopUp/SelectFix'; 
require( './style.css');


export default class footer extends Component {
    state = {
        F_user:sessionStorage.getItem('Username'),       
        F_Contract : "",        F_SumAmount : 0,        
        F_Department: "",       F_Project: "",
        F_DiscountPercent:"0",   F_Discount:"0",        
        F_Allocation: "",       F_Branch:"",        
        F_Value:"",             F_Deposit:"",        
        F_Withholding:"",       F_VatPercent:7.00,        
        F_Vat:0,                F_SalesType:"",        
        F_DeliveryLocation:"",  F_SamVat:"",      
        
        F_Note:"",              F_Note2:"",        
        F_ValueExcept:"",       F_Currency:"บาท",        
        F_Rate:"",              F_SumAll:0,
        F_Total:"",             F_Expired:"",        
        F_StandPrice:"0",        F_StandPrice2:"",

        PopUpTYpe:"",
    };

    valueChange = (data) => {
        switch (data.target.name) {
            case "F_Contract" :         this.setState({ F_Contract: data.target.value });       break;
            case "F_Department" :       this.setState({ F_Department: data.target.value });     break;
            case "F_Project" :          this.setState({ F_Project: data.target.value });        break;
            case "F_DiscountPercent" :  this.setState({ F_DiscountPercent: data.target.value });break;
            case "F_Discount" :         this.setState({ F_Discount: data.target.value });       break;
            case "F_Allocation" :       this.setState({ F_Allocation: data.target.value });     break;
            case "F_Branch" :           this.setState({ F_Branch: data.target.value });         break;
            case "F_Value" :            this.setState({ F_Value: data.target.value });          break;
            case "F_Deposit" :          this.setState({ F_Deposit: data.target.value });        break;
            case "F_Withholding" :      this.setState({ F_Withholding: data.target.value });    break;
            case "F_VatPercent" :       this.setState({ F_VatPercent: data.target.value });     break;
            case "F_Vat" :              this.setState({ F_Vat: data.target.value });            break;
            case "F_SalesType" :        this.setState({ F_SalesType: data.target.value });      break;
            case "F_DeliveryLocation" : this.setState({ F_DeliveryLocation: data.target.value });break;
            case "F_SamVat" :           this.setState({ F_SamVat: data.target.value });         break;
            case "F_Note" :             this.setState({ F_Note: data.target.value });           break;
            case "F_Note2" :            this.setState({ F_Note2: data.target.value });          break;
            case "F_ValueExcept" :      this.setState({ F_ValueExcept: data.target.value });    break;
            case "F_Currency" :         this.setState({ F_Currency: data.target.value });       break;
            case "F_Rate" :             this.setState({ F_Rate: data.target.value });           break;
            case "F_SumAll" :           this.setState({ F_SumAll: data.target.value });         break;
            case "F_Total" :            this.setState({ F_Total: data.target.value });          break;
            case "F_Expired" :          this.setState({ F_Expired: data.target.value });        break;
            case "F_StandPrice" :       this.setState({ F_StandPrice: data.target.value });     break;
            case "F_StandPrice2" :      this.setState({ F_StandPrice2: data.target.value });    break;

            case "F_SumAmount" :        this.setState({ F_SumAmount: data.target.value });      break;

            default: break;
            
        }
        setTimeout(() => {
            this.props.ReturnValue_F(this.state);
            
        }, 200);
    }
    componentDidMount() {
        setInterval(() => {
            this.props.ReturnValue_F(this.state);
        }, 500);
    }

    SetPopup=(data)=>{
        this.setState({ PopUpTYpe : data });
        this.setState({showPopup: !this.state.showPopup});
    }

    /* มีไว้เพื่อปิด */
    togglePopup(value) {
        this.setState({showPopup: !this.state.showPopup});
    }

    Get_PopUpOther = (data) =>{
        switch (this.state.PopUpTYpe) {
            case "Contract" :         this.setState({ F_Contract: data });       break;
            case "Department" :       this.setState({ F_Department: data });     break;
            case "Project" :          this.setState({ F_Project: data });        break;
            case "DiscountPercent" :  this.setState({ F_DiscountPercent: data });break;
            case "Discount" :         this.setState({ F_Discount: data });       break;
            case "Allocation" :       this.setState({ F_Allocation: data });     break;
            case "Branch" :           this.setState({ F_Branch: data });         break;
            case "Value" :            this.setState({ F_Value: data });          break;
            case "Deposit" :          this.setState({ F_Deposit: data });        break;
            case "Withholding" :      this.setState({ F_Withholding: data });    break;
            case "VatPercent" :       this.setState({ F_VatPercent: data });     break;
            case "Vat" :              this.setState({ F_Vat: data });            break;
            case "SalesType" :        this.setState({ F_SalesType: data });      break;
            case "DeliveryLocation" : this.setState({ F_DeliveryLocation: data });break;
            case "SamVat" :           this.setState({ F_SamVat: data });         break;
            case "Note" :             this.setState({ F_Note: data });           break;
            case "ValueExcept" :      this.setState({ F_ValueExcept: data });    break;
            case "Currency" :         this.setState({ F_Currency: data });       break;
            case "Rate" :             this.setState({ F_Rate: data });           break;
            case "SumAll" :           this.setState({ F_SumAll: data });         break;

            default: break;
        }
        this.setState({showPopup: !this.state.showPopup}); 
    }


    SelectSetData=(type,data)=>{
        switch (type) {
            case "SaleType": this.setState({F_SalesType:data});break;
            case "Calendar-up": this.setState({F_Expired:data});break;
            case "Calendar2-up": this.setState({F_StandPrice2:data});break;
            default: break;
        }
    }

    onChange = (date) => {this.setState({ date }); alert(date) }

    render() {
        return (
            <div class="container" style={{minHeight: this.props.HFooter,minWidth:this.props.WContent,marginTop:7,marginBottom:7}}>
                <div class="cs-order-popup">
                    {this.state.showPopup ? <PopUpOther closePopup={this.togglePopup.bind(this)} Get_PopUpOther={this.Get_PopUpOther} type={this.state.PopUpTYpe}/>  : null }
                </div>
               
                <div class='row cs-order-book'>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">พนักงานขาย:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_user" value={this.state.F_user} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-caret-down" ></i></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">ผู้ติดต่อ:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Contract" value={this.state.F_Contract}  onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon" name="F_Contract_btnPopup" ><i class="fas fa-caret-down" ></i></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">รวมจำนวนเงิน:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_SumAmount" value={this.state.F_SumAmount} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-calculator"></i></span> 
                        </div>
                    </div>
                </div>

                <div class='row cs-order-book'>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">แผนก:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Department" value={this.state.F_Department} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"  onClick={this.SetPopup.bind(null,'Department')}><i class="fas fa-search"></i></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">โครงการ:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Project" value={this.state.F_Project} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null,'Project')}><i class="fas fa-search" ></i></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-col2">
                            <span class="input-group-addon">ส่วนลด%,บาท:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_DiscountPercent" value={this.state.F_DiscountPercent} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon">%</span>
                        </div>
                        <div class="input-group group-col1">
                            <div> </div>
                        </div>
                        <div class="input-group group-col4">
                            <input id="id1" type="text" class="form-control input-custom" name="F_Discount" value={this.state.F_Discount} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-calculator"></i></span> 
                        </div>
                    </div>
                </div>

                <div class='row cs-order-book'>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">การจัดสรร:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Allocation" value={this.state.F_Allocation} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"  onClick={this.SetPopup.bind(null,'Allocation')}><i class="fas fa-search"></i></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">สาขา:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Branch" value={this.state.F_Branch} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null,'Branch')}><i class="fas fa-search" ></i></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">มูลค่าสินค้า:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Value" value={this.state.F_Value} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-calculator"></i></span> 
                        </div>
                    </div>
                </div>

                <div class='row cs-order-book'>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">สกุลเงิน:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Currency" value={this.state.F_Currency} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-caret-down" ></i></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">อัตราแลกเปลี่ยน:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Rate" value={this.state.F_Rate} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-calculator"></i></span> 
                        </div>
                    </div>
                    

                     <div class='col-sm-4 '>  
                        <div class="input-group group-col2">
                            <span class="input-group-addon">ภาษีมูลค่าเพิ่ม:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_VatPercent" value={this.state.F_VatPercent} onChange={this.valueChange}/>                           
                            <span class="input-group-addon textIcon">%</span>
                        </div>
                        <div class="input-group group-col1">

                        </div>
                        <div class="input-group group-col4">
                            <input id="id1" type="text" class="form-control input-custom" name="F_Vat" value={this.state.F_Vat} onChange={this.valueChange}/> 
                          <span class="input-group-addon textIcon"><i class="fas fa-calculator"></i></span>                              
                        </div>
                    </div>

                </div>

                <div class='row cs-order-book'>
                    <div class='col-sm-8 '>  
                        <div class="input-group group-custom-remark2">
                            <span class="input-group-addon">หมายเหตุ:</span>
                            <input   id="id1" type="text" class="form-control input-custom" name="F_Note" value={this.state.F_Note} onChange={this.valueChange}/>
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">มูลค่ารวมภาษี:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_SamVat" value={this.state.F_SamVat} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-calculator"></i></span> 
                        </div>
                    </div>
                </div>

                <div class='row cs-order-book'>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">หมายเหตุ 2:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Note2" value={this.state.F_Note2} onChange={this.valueChange}/>
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">หักเงินมัดจำ:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Deposit" value={this.state.F_Deposit} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-caret-down" ></i></span> 
                        </div>
                    </div>
                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">มูลค่ายกเว้น :</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_ValueExcept" value={this.state.F_ValueExcept} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-calculator"></i></span> 
                        </div>
                    </div>

                </div>      

                <div class='row cs-order-book'>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-col2">
                            <span class="input-group-addon">ยืนราคา(วัน):</span>
                            <input id="id1" type="number" min='0' class="form-control input-custom" name="F_StandPrice" value={this.state.F_StandPrice} onChange={this.valueChange}/>                           
                        </div>
                        <div class="input-group group-col1"></div>
                        <div class="input-group group-col4">
                            <input id="id1" type="text" class="form-control input-custom" name="F_StandPrice2" value={this.state.F_StandPrice2} onChange={this.valueChange} readOnly/> 
                                <span class="input-group-addon textIcon">
                                    <SelectFix type={"Calendar2-up"} SelectSetData={this.SelectSetData} tomorrow={this.state.F_StandPrice} />
                                </span>                              
                        </div>
                    </div>

                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">หมดอายุ:</span>
                            <input id="id1" type="text" class="form-control input-custom" name="F_Expired" value={this.state.F_Expired} onChange={this.valueChange} readOnly/>
                            <span class="input-group-addon textIcon"><SelectFix type={"Calendar-up"} SelectSetData={this.SelectSetData}/></span> 
                        </div>
                    </div>
                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">รวมเงินทั้งสิ้น:</span>       
                            <input id="id1" type="text" class="form-control input-custom" name="F_Total" value={this.state.F_Total} onChange={this.valueChange}/>
                            <span class="input-group-addon textIcon"><i class="fas fa-calculator"></i></span> 
                        </div>
                    </div>

                </div>

              </div >
        );
    }
}